import GlobalLayout from 'components/common/general/layouts/GlobalLayout';
import React from 'react';
import RFQProposalSidebar from '../RFQProposalSidebar';
import { RightSectionStyled } from './styles';

const RFQStatusLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <GlobalLayout
      leftSection={<RFQProposalSidebar />}
      rightSection={<RightSectionStyled>{children} </RightSectionStyled>}
    />
  );
};

export default RFQStatusLayout;
